import { Link } from "react-router-dom";

const practiceLinks = [
  { label: "Health Law", href: "/practice-areas/health-law" },
  { label: "Business Law", href: "/practice-areas/business-law" },
  { label: "Litigation", href: "/practice-areas/litigation" },
  { label: "Real Estate Law", href: "/practice-areas/real-estate-law" },
  { label: "Contract Disputes", href: "/practice-areas/contract-disputes" },
  { label: "Medicare Compliance", href: "/practice-areas/medicare-compliance" },
];

const firmLinks = [
  { label: "About the Firm", href: "/about" },
  { label: "Our Approach", href: "/about#approach" },
  { label: "Case Results", href: "/results" },
  { label: "Locations", href: "/locations/philadelphia" },
  { label: "Contact Us", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#111827] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/99cc58db-129a-4686-a4b4-ed4119f2d499/cece8882-bf3a-4abf-a433-1e2e0b2a4be6_logo-gosfield-white.png?v=7205bb5119f4d5eb9bba279978db363a"
                alt="Alice G. Gosfield & Associates, P.C."
                className="h-10 w-auto object-contain mb-1"
              />
              <span className="block text-[10px] tracking-[0.2em] text-slate-400 uppercase font-inter">Est. 1986</span>
            </div>
            <p className="text-slate-400 text-sm font-inter leading-relaxed mb-6">
              A boutique health law firm providing strategic legal counsel to physicians, health systems, and health care organizations nationwide.
            </p>
            <div className="flex gap-3">
              {["linkedin-box", "twitter-x", "facebook-box"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-white/20 text-slate-400 hover:border-[#C9A961] hover:text-[#C9A961] transition-all duration-200 cursor-pointer"
                >
                  <i className={`ri-${icon}-fill text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Practice Areas */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] text-[#C9A961] uppercase font-inter font-medium mb-5">Practice Areas</h4>
            <ul className="flex flex-col gap-3">
              {practiceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-400 hover:text-white font-inter transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Firm */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] text-[#C9A961] uppercase font-inter font-medium mb-5">The Firm</h4>
            <ul className="flex flex-col gap-3">
              {firmLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-400 hover:text-white font-inter transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] text-[#C9A961] uppercase font-inter font-medium mb-5">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-[#C9A961] text-base" />
                </span>
                <span className="text-sm text-slate-400 font-inter leading-relaxed">
                  2309 Delancey Pl.<br />Philadelphia, PA 19103
                </span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#C9A961] text-base" />
                </span>
                <a href="tel:+12157352384" className="text-sm text-slate-400 hover:text-white font-inter transition-colors cursor-pointer">
                  (215) 735-2384
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#C9A961] text-base" />
                </span>
                <a href="mailto:info@gosfield.com" className="text-sm text-slate-400 hover:text-white font-inter transition-colors cursor-pointer">
                  info@gosfield.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-[#C9A961] text-base" />
                </span>
                <span className="text-sm text-slate-400 font-inter leading-relaxed">
                  Mon – Fri: 9:00 AM – 5:30 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-slate-500 font-inter">
            &copy; 2026 Alice G. Gosfield & Associates, P.C. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-xs text-slate-500 hover:text-slate-300 font-inter transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" rel="nofollow" className="text-xs text-slate-500 hover:text-slate-300 font-inter transition-colors cursor-pointer">Terms of Use</a>
            <a href="#" rel="nofollow" className="text-xs text-slate-500 hover:text-slate-300 font-inter transition-colors cursor-pointer">Disclaimer</a>
          </div>
        </div>

        <p className="mt-6 text-xs text-slate-600 font-inter leading-relaxed text-center">
          The materials on this website are for informational purposes only and do not constitute legal advice. No attorney-client relationship is formed by accessing this site. Please consult a qualified attorney for advice specific to your situation.
        </p>
      </div>
    </footer>
  );
}
